import React from "react";
import css from "./withTransition.module.scss";

const withTransition =
  <T,>(Component: React.FC<T>) =>
  (props: T) => {
    const WrappedComponent = (props: T) => (
      <div className={css.transition}>
        <Component {...props} />
      </div>
    );

    return WrappedComponent(props);
  };

export default withTransition;
